import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ApiService } from '../core/api.service';

@Component({
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule],
  template: `
  <div class="card">
    <h3 class="m-0 mb-3">HR Employees (perm: hr:employees.read)</h3>
    <button pButton icon="pi pi-refresh" label="Reload" (click)="load()"></button>
    <p-table class="mt-3" [value]="rows">
      <ng-template pTemplate="header">
        <tr><th>Id</th><th>Name</th></tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr><td>{{r.id}}</td><td>{{r.name}}</td></tr>
      </ng-template>
    </p-table>
  </div>
  `
})
export class HrDemoComponent {
  api = inject(ApiService);
  rows: any[] = [];

  load() {
    this.api.get<any[]>('/api/hr-demo/employees').subscribe({
      next: d => this.rows = d,
      error: e => alert('Forbidden or error: ' + (e?.status || ''))
    });
  }
}
